export function initFileSelection(app) {
  if (!app.ports.openFileDialogPort || !app.ports.onFileSelectedPort) {
    return;
  }

  app.ports.openFileDialogPort.subscribe((acceptedTypes) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.style.display = "none";
    fileInput.accept = acceptedTypes || "*/*";
    fileInput.multiple = true;

    fileInput.addEventListener("change", (event) => {
      const files = Array.from(event.target.files);

      if (files.length > 0) {
        const fileInfos = files.map((file) => ({
          name: file.name,
          size: file.size,
          type: file.type || "application/octet-stream",
        }));
        app.ports.onFileSelectedPort.send(fileInfos);
      } else {
        app.ports.onFileSelectedPort.send([]);
      }

      document.body.removeChild(fileInput);
    });

    document.body.appendChild(fileInput);
    fileInput.click();
  });
}
